import { render, staticRenderFns } from "./salesRegister.vue?vue&type=template&id=f53616fc&scoped=true"
import script from "./salesRegister.vue?vue&type=script&lang=js"
export * from "./salesRegister.vue?vue&type=script&lang=js"
import style0 from "./salesRegister.vue?vue&type=style&index=0&id=f53616fc&prod&scoped=true&lang=scss"
import style1 from "./salesRegister.vue?vue&type=style&index=1&id=f53616fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53616fc",
  null
  
)

export default component.exports